module.exports = [
	{
		"fund_id": "FSUSA00B4P",
		"investment_vehicle_id": "FEUSA0000F",
		"ticker": "IVW",
		"fund_legal_name": "iShares S&P 500 Growth ETF",
		"morningstar_category_name": "Large Growth",
		"fund_net_assets": 65504682787,
		"grade_fossil": 3,
		"grade_deforestation": 2,
		"grade_tobacco": 4,
		"grade_gender_equality": 4,
		"grade_dei": 2,
		"grade_rji": 3,
		"grade_hrc": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 2,
		"c2f5coogutweight": 0.036787313456327346,
		"cl_weight": 0.3133314215081556,
		"fossil_bank_score": 17.1459,
		"fossil_insure_score": 15.4381,
		"wff_mil_weight": 0.04668421950213307,
		"mmc_weight": 0.04668421950213307,
		"cm_weight": 0.002339231346889945,
		"nw_weight": 0.013131429131656443,
		"wff_civ_weight": 0.009760654022537328,
		"gm_weight": 0,
		"gr_weight": 0.009760654022537328,
		"t_all_weight": 0.006045246740676103,
		"to_weight": 0.006045246740676103,
		"tm_weight": 0,
		"po_producer_weight": 0,
		"po_financier_weight": 0.018764899654839143,
		"po_consumer_weight": 0.07728743930969834,
		"pp_weight": 0.22887304965403563,
		"borders_weight": 0.21607312147556912,
		"pp_high_weight": 0.004246489908149574,
		"borders_high_weight": 0.02176289508150495,
		"pff_all_weight": 0.2539341178070252,
		"pff_all_high_weight": 0.02176289508150495,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.522655857216925,
		"gef_score_a": 25.665657634551838,
		"gef_score_b": 9.085625252395403,
		"gef_score_c": 18.184316864984044,
		"gef_score_d": 0.5870561052652032,
		"gef_score_a_norm": 64.1641440863796,
		"gef_score_b_norm": 30.285417507984675,
		"gef_score_c_norm": 90.92158432492022,
		"gef_score_d_norm": 5.870561052652032,
		"prospectus_net_expense_ratio": 0.18,
		"trailing_return_m1": 5.27894,
		"trailing_return_m3": 9.75311,
		"trailing_return_m6": 30.47217,
		"trailing_return_y1": 26.67332,
		"trailing_return_y3": 28.73969,
		"trailing_return_y5": 16.67009,
		"trailing_return_y10": 17.41321,
		"trailing_return_y15": 16.4343,
		"trailing_return_y20": 12.56202,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "S&P 500 Growth",
		"footprint": 22.882636213323696,
		"intensity": 71.94591785242196,
		"name": "IVW - iShares S&P 500 Growth ETF",
		"label": "IVW - iShares S&P 500 Growth ETF"
	},
	{
		"fund_id": "FSUSA00B4Q",
		"investment_vehicle_id": "FEUSA0000G",
		"ticker": "IVE",
		"fund_legal_name": "iShares S&P 500 Value ETF",
		"morningstar_category_name": "Large Value",
		"fund_net_assets": 41573811646,
		"grade_fossil": 5,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.12419961379324618,
		"cl_weight": 0.2321522835217488,
		"fossil_bank_score": 48.7946,
		"fossil_insure_score": 26.6654,
		"wff_mil_weight": 0.04632349028692747,
		"mmc_weight": 0.04632349028692747,
		"cm_weight": 0.01294301187633459,
		"nw_weight": 0.03854929252727038,
		"wff_civ_weight": 0.008853475980330294,
		"gm_weight": 0.0030874109459195728,
		"gr_weight": 0.005766065034410722,
		"t_all_weight": 0.02723994925868017,
		"to_weight": 0.0068116708234467575,
		"tm_weight": 0.020428278435233413,
		"po_producer_weight": 0.0033748003643645818,
		"po_financier_weight": 0.0396975935757418,
		"po_consumer_weight": 0.14190651273548893,
		"pp_weight": 0.1570859125466888,
		"borders_weight": 0.15147558523872448,
		"pp_high_weight": 0.0018065522601337766,
		"borders_high_weight": 0.0198714654976814,
		"pff_all_weight": 0.19680451466452886,
		"pff_all_high_weight": 0.0198714654976814,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 55.88280168782836,
		"gef_score_a": 27.60543507775852,
		"gef_score_b": 8.963192094044711,
		"gef_score_c": 18.60049327437195,
		"gef_score_d": 0.7136812416478063,
		"gef_score_a_norm": 69.0135876943963,
		"gef_score_b_norm": 29.877306980149037,
		"gef_score_c_norm": 93.00246637185975,
		"gef_score_d_norm": 7.1368124164780635,
		"prospectus_net_expense_ratio": 0.18,
		"trailing_return_m1": 1.75161,
		"trailing_return_m3": 6.16205,
		"trailing_return_m6": 9.30337,
		"trailing_return_y1": 6.58582,
		"trailing_return_y3": 19.3781,
		"trailing_return_y5": 15.12218,
		"trailing_return_y10": 11.85006,
		"trailing_return_y15": 11.79383,
		"trailing_return_y20": 8.50576,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "S&P 500 Value",
		"footprint": 147.335576324996,
		"intensity": 220.5813107990886,
		"name": "IVE - iShares S&P 500 Value ETF",
		"label": "IVE - iShares S&P 500 Value ETF"
	},
	{
		"fund_id": "FSUSA00B5I",
		"investment_vehicle_id": "FEUSA00018",
		"ticker": "IWO",
		"fund_legal_name": "iShares Russell 2000 Growth ETF",
		"morningstar_category_name": "Small Growth",
		"fund_net_assets": 12930349040,
		"grade_fossil": 3,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 5,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 3,
		"c2f5coogutweight": 0.027351597232718943,
		"cl_weight": 0,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.04064011801501422,
		"mmc_weight": 0.04064011801501422,
		"cm_weight": 0,
		"nw_weight": 0.018398262449705355,
		"wff_civ_weight": 0.00015884296232709328,
		"gm_weight": 0.00015884296232709328,
		"gr_weight": 0,
		"t_all_weight": 0.0009934123652892016,
		"to_weight": 0.0009934123652892016,
		"tm_weight": 0,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.0016374414613096462,
		"pp_weight": 0.005987625627114128,
		"borders_weight": 0.01485020035674739,
		"pp_high_weight": 0.0030077357410395957,
		"borders_high_weight": 0.005627167762311685,
		"pff_all_weight": 0.01798893320514901,
		"pff_all_high_weight": 0.005786010724638778,
		"pff_all_extreme_weight": 0.0021556775065954313,
		"gef_score_norm": 36.05863183828086,
		"gef_score_a": 18.31288897491857,
		"gef_score_b": 3.218978244353435,
		"gef_score_c": 14.522780519134958,
		"gef_score_d": 0.00398409988128279,
		"gef_score_a_norm": 45.782222437296426,
		"gef_score_b_norm": 10.729927481178118,
		"gef_score_c_norm": 72.6139025956748,
		"gef_score_d_norm": 0.039840998812827905,
		"prospectus_net_expense_ratio": 0.24,
		"trailing_return_m1": 4.15804,
		"trailing_return_m3": 12.18301,
		"trailing_return_m6": 25.53499,
		"trailing_return_y1": 13.44745,
		"trailing_return_y3": 16.59078,
		"trailing_return_y5": 8.33489,
		"trailing_return_y10": 9.88596,
		"trailing_return_y15": 11.03543,
		"trailing_return_y20": 8.78505,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "Russell 2000 Growth",
		"footprint": 138.53454201517556,
		"intensity": 156.10505164940264,
		"name": "IWO - iShares Russell 2000 Growth ETF",
		"label": "IWO - iShares Russell 2000 Growth ETF"
	},
	{
		"fund_id": "FSUSA00B5J",
		"investment_vehicle_id": "FEUSA00019",
		"ticker": "IWN",
		"fund_legal_name": "iShares Russell 2000 Value ETF",
		"morningstar_category_name": "Small Value",
		"fund_net_assets": 11966026177,
		"grade_fossil": 5,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 4,
		"grade_dei": 5,
		"grade_rji": 4,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.11315827889780801,
		"cl_weight": 0.006409556023305726,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.032280330353690365,
		"mmc_weight": 0.032280330353690365,
		"cm_weight": 0.005549326121507632,
		"nw_weight": 0.007308426953172198,
		"wff_civ_weight": 0.0037317472891263627,
		"gm_weight": 0.0012526775075048118,
		"gr_weight": 0.0024790697816215513,
		"t_all_weight": 0.0020705268329102543,
		"to_weight": 0.0011177946851830037,
		"tm_weight": 0.0009527321477272505,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.005964334730789477,
		"pp_weight": 0.0020436087951494846,
		"borders_weight": 0.005464389888128226,
		"pp_high_weight": 0.0019854293388980484,
		"borders_high_weight": 0.0021374078696161365,
		"pff_all_weight": 0.005858270607171558,
		"pff_all_high_weight": 0.0024731091324080323,
		"pff_all_extreme_weight": 0.001448875501996701,
		"gef_score_norm": 38.7874677017633,
		"gef_score_a": 19.80740302002049,
		"gef_score_b": 3.5198044025288,
		"gef_score_c": 15.392609421169428,
		"gef_score_d": 0.06765085804893842,
		"gef_score_a_norm": 49.518507550051226,
		"gef_score_b_norm": 11.732681341762666,
		"gef_score_c_norm": 76.96304710584714,
		"gef_score_d_norm": 0.6765085804893841,
		"prospectus_net_expense_ratio": 0.24,
		"trailing_return_m1": 2.00208,
		"trailing_return_m3": 12.54297,
		"trailing_return_m6": 18.08496,
		"trailing_return_y1": 7.69614,
		"trailing_return_y3": 13.3061,
		"trailing_return_y5": 14.33408,
		"trailing_return_y10": 9.04668,
		"trailing_return_y15": 9.37097,
		"trailing_return_y20": 7.11699,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "Russell 2000 Value",
		"footprint": 210.67117372007064,
		"intensity": 146.1275380116073,
		"name": "IWN - iShares Russell 2000 Value ETF",
		"label": "IWN - iShares Russell 2000 Value ETF"
	},
	{
		"fund_id": "FSUSA00B5L",
		"investment_vehicle_id": "FEUSA0001B",
		"ticker": "IWF",
		"fund_legal_name": "iShares Russell 1000 Growth ETF",
		"morningstar_category_name": "Large Growth",
		"fund_net_assets": 121547524048,
		"grade_fossil": 3,
		"grade_deforestation": 2,
		"grade_tobacco": 1,
		"grade_gender_equality": 4,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 2,
		"c2f5coogutweight": 0.017472736149721554,
		"cl_weight": 0.3931260291099774,
		"fossil_bank_score": 1.8386,
		"fossil_insure_score": 0.0656,
		"wff_mil_weight": 0.03466929182153813,
		"mmc_weight": 0.03466929182153813,
		"cm_weight": 0.0013193859275808556,
		"nw_weight": 0.013355393652634131,
		"wff_civ_weight": 0.0014400612417767335,
		"gm_weight": 0,
		"gr_weight": 0.0014400612417767335,
		"t_all_weight": 0,
		"to_weight": 0,
		"tm_weight": 0,
		"po_producer_weight": 0,
		"po_financier_weight": 0.0019835242466339775,
		"po_consumer_weight": 0.07773118251278274,
		"pp_weight": 0.22799804919429922,
		"borders_weight": 0.22602009811248297,
		"pp_high_weight": 0.0027407589854633015,
		"borders_high_weight": 0.01661726423842353,
		"pff_all_weight": 0.24287477629076315,
		"pff_all_high_weight": 0.01661726423842353,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.28848167524164,
		"gef_score_a": 25.174468544887365,
		"gef_score_b": 9.32446334289121,
		"gef_score_c": 18.1600263929007,
		"gef_score_d": 0.6295233945477057,
		"gef_score_a_norm": 62.93617136221841,
		"gef_score_b_norm": 31.081544476304035,
		"gef_score_c_norm": 90.8001319645035,
		"gef_score_d_norm": 6.295233945477056,
		"prospectus_net_expense_ratio": 0.18,
		"trailing_return_m1": 5.29457,
		"trailing_return_m3": 10.45948,
		"trailing_return_m6": 30.09905,
		"trailing_return_y1": 25.30384,
		"trailing_return_y3": 31.39639,
		"trailing_return_y5": 17.37502,
		"trailing_return_y10": 18.6181,
		"trailing_return_y15": 17.14406,
		"trailing_return_y20": 13.13059,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "Russell 1000 Growth",
		"footprint": 27.104039919030285,
		"intensity": 72.28267458266703,
		"name": "IWF - iShares Russell 1000 Growth ETF",
		"label": "IWF - iShares Russell 1000 Growth ETF"
	},
	{
		"fund_id": "FSUSA00B5M",
		"investment_vehicle_id": "FEUSA0001C",
		"ticker": "IWD",
		"fund_legal_name": "iShares Russell 1000 Value ETF",
		"morningstar_category_name": "Large Value",
		"fund_net_assets": 64302456134,
		"grade_fossil": 5,
		"grade_deforestation": 3,
		"grade_tobacco": 5,
		"grade_gender_equality": 3,
		"grade_dei": 4,
		"grade_rji": 5,
		"grade_hrc": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.14059873159779093,
		"cl_weight": 0.09723659298353371,
		"fossil_bank_score": 59.1265,
		"fossil_insure_score": 40.67,
		"wff_mil_weight": 0.062132419827534736,
		"mmc_weight": 0.062132419827534736,
		"cm_weight": 0.01288464970005294,
		"nw_weight": 0.03898118777651792,
		"wff_civ_weight": 0.01722341566062082,
		"gm_weight": 0.0029265267976655318,
		"gr_weight": 0.014296888862955286,
		"t_all_weight": 0.030240890562880936,
		"to_weight": 0.012464680549795078,
		"tm_weight": 0.017776210013085856,
		"po_producer_weight": 0.0029434820182254167,
		"po_financier_weight": 0.05242915813734743,
		"po_consumer_weight": 0.1186067273183904,
		"pp_weight": 0.1226540889238654,
		"borders_weight": 0.10693448312998491,
		"pp_high_weight": 0.003456683861399293,
		"borders_high_weight": 0.02461756262521297,
		"pff_all_weight": 0.17070467128474992,
		"pff_all_high_weight": 0.02461756262521297,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.89645488920126,
		"gef_score_a": 27.272610634433462,
		"gef_score_b": 7.899973002598806,
		"gef_score_c": 18.17745191132504,
		"gef_score_d": 0.5464193408334532,
		"gef_score_a_norm": 68.18152658608365,
		"gef_score_b_norm": 26.33324334199602,
		"gef_score_c_norm": 90.8872595566252,
		"gef_score_d_norm": 5.464193408334532,
		"prospectus_net_expense_ratio": 0.18,
		"trailing_return_m1": 1.4812,
		"trailing_return_m3": 5.29154,
		"trailing_return_m6": 9.23137,
		"trailing_return_y1": 9.24972,
		"trailing_return_y3": 16.76855,
		"trailing_return_y5": 13.67542,
		"trailing_return_y10": 10.53617,
		"trailing_return_y15": 11.04198,
		"trailing_return_y20": 8.01343,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "Russell 1000 Value",
		"footprint": 163.94657295457372,
		"intensity": 244.40950089263998,
		"name": "IWD - iShares Russell 1000 Value ETF",
		"label": "IWD - iShares Russell 1000 Value ETF"
	},
	{
		"fund_id": "FSUSA00B6U",
		"investment_vehicle_id": "FEUSA0002J",
		"ticker": "OEF",
		"fund_legal_name": "iShares S&P 100 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 27160457887,
		"grade_fossil": 3,
		"grade_deforestation": 2,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": 1,
		"grade_rji": 1,
		"grade_hrc": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 2,
		"c2f5coogutweight": 0.0530818770220227,
		"cl_weight": 0.35979290605840175,
		"fossil_bank_score": 42.7195,
		"fossil_insure_score": 23.1924,
		"wff_mil_weight": 0.03997264299567054,
		"mmc_weight": 0.03997264299567054,
		"cm_weight": 0.004513300010744004,
		"nw_weight": 0.0246764172158696,
		"wff_civ_weight": 0.011025279726742129,
		"gm_weight": 0,
		"gr_weight": 0.011025279726742129,
		"t_all_weight": 0.02161660126182143,
		"to_weight": 0.008870734552335542,
		"tm_weight": 0.01274586670948589,
		"po_producer_weight": 0,
		"po_financier_weight": 0.039250252201828706,
		"po_consumer_weight": 0.12940643244504282,
		"pp_weight": 0.26107057061476446,
		"borders_weight": 0.2479379899849461,
		"pp_high_weight": 0,
		"borders_high_weight": 0.01976301755936478,
		"pff_all_weight": 0.2994351557141979,
		"pff_all_high_weight": 0.01976301755936478,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 55.83346155528955,
		"gef_score_a": 26.72259147824271,
		"gef_score_b": 9.892514229484457,
		"gef_score_c": 18.409167288109895,
		"gef_score_d": 0.8091885594360796,
		"gef_score_a_norm": 66.80647869560677,
		"gef_score_b_norm": 32.975047431614854,
		"gef_score_c_norm": 92.04583644054948,
		"gef_score_d_norm": 8.091885594360795,
		"prospectus_net_expense_ratio": 0.2,
		"trailing_return_m1": 4.31959,
		"trailing_return_m3": 9.62544,
		"trailing_return_m6": 23.54415,
		"trailing_return_y1": 21.37872,
		"trailing_return_y3": 28.5518,
		"trailing_return_y5": 17.83207,
		"trailing_return_y10": 16.50358,
		"trailing_return_y15": 15.26598,
		"trailing_return_y20": 11.33017,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "S&P 100",
		"footprint": 50.295241468364594,
		"intensity": 120.77831715622968,
		"name": "OEF - iShares S&P 100 ETF",
		"label": "OEF - iShares S&P 100 ETF"
	},
	{
		"fund_id": "FSUSA04YKB",
		"investment_vehicle_id": "FEUSA04ACN",
		"ticker": "ILCB",
		"fund_legal_name": "iShares Morningstar U.S. Equity ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 1137945026,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 3,
		"grade_rji": 3,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.075282668305191,
		"cl_weight": 0.2693996543082921,
		"fossil_bank_score": 30.6906,
		"fossil_insure_score": 19.9769,
		"wff_mil_weight": 0.045595856109487215,
		"mmc_weight": 0.045595856109487215,
		"cm_weight": 0.006833688299877179,
		"nw_weight": 0.024831642289586894,
		"wff_civ_weight": 0.008962567354479312,
		"gm_weight": 0.0013974896411105902,
		"gr_weight": 0.007565077713368721,
		"t_all_weight": 0.015158223978208846,
		"to_weight": 0.006206657018624413,
		"tm_weight": 0.008951566959584434,
		"po_producer_weight": 0.001249193966678853,
		"po_financier_weight": 0.02751829663050115,
		"po_consumer_weight": 0.1035756646758782,
		"pp_weight": 0.1922875615580432,
		"borders_weight": 0.18334751080134387,
		"pp_high_weight": 0.002981378956098596,
		"borders_high_weight": 0.020319223284117265,
		"pff_all_weight": 0.22331964134473895,
		"pff_all_high_weight": 0.020319223284117265,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 54.183329193196926,
		"gef_score_a": 26.365806317744255,
		"gef_score_b": 8.906129159514057,
		"gef_score_c": 18.28584393811959,
		"gef_score_d": 0.6255497778056475,
		"gef_score_a_norm": 65.91451579436064,
		"gef_score_b_norm": 29.68709719838019,
		"gef_score_c_norm": 91.42921969059795,
		"gef_score_d_norm": 6.255497778056475,
		"prospectus_net_expense_ratio": 0.03,
		"trailing_return_m1": 3.63739,
		"trailing_return_m3": 8.0992,
		"trailing_return_m6": 20.41944,
		"trailing_return_y1": 18.07009,
		"trailing_return_y3": 25.03333,
		"trailing_return_y5": 15.23463,
		"trailing_return_y10": 14.69565,
		"trailing_return_y15": 14.4656,
		"trailing_return_y20": 11.14859,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "Morningstar U.S. Equity",
		"footprint": 92.78032831872646,
		"intensity": 180.94636729905469,
		"name": "ILCB - iShares Morningstar U.S. Equity ETF",
		"label": "ILCB - iShares Morningstar U.S. Equity ETF"
	},
	{
		"fund_id": "FSUSA04YKE",
		"investment_vehicle_id": "FEUSA04ACQ",
		"ticker": "IMCB",
		"fund_legal_name": "iShares Morningstar Mid-Cap ETF",
		"morningstar_category_name": "Mid-Cap Blend",
		"fund_net_assets": 1208039798,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 1,
		"grade_gender_equality": 1,
		"grade_dei": 1,
		"grade_rji": 1,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 1,
		"c2f5coogutweight": 0.13962407940068275,
		"cl_weight": 0.04858467627935333,
		"fossil_bank_score": 4.461,
		"fossil_insure_score": 13.6992,
		"wff_mil_weight": 0.033994966836341935,
		"mmc_weight": 0.033994966836341935,
		"cm_weight": 0.006063841203449005,
		"nw_weight": 0.0191519761404447,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0,
		"to_weight": 0,
		"tm_weight": 0,
		"po_producer_weight": 0.006156533263645428,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.04978212645608552,
		"pp_weight": 0.0342178550002118,
		"borders_weight": 0.033591813248896575,
		"pp_high_weight": 0.008322346307982606,
		"borders_high_weight": 0.02077776005724766,
		"pff_all_weight": 0.050686064175472875,
		"pff_all_high_weight": 0.02077776005724766,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 49.98284585567638,
		"gef_score_a": 25.53834980073356,
		"gef_score_b": 6.486796143222274,
		"gef_score_c": 17.774167496162896,
		"gef_score_d": 0.1835324155481335,
		"gef_score_a_norm": 63.8458745018339,
		"gef_score_b_norm": 21.622653810740914,
		"gef_score_c_norm": 88.87083748081449,
		"gef_score_d_norm": 1.8353241554813347,
		"prospectus_net_expense_ratio": 0.04,
		"trailing_return_m1": 0.99515,
		"trailing_return_m3": 4.71864,
		"trailing_return_m6": 12.99804,
		"trailing_return_y1": 10.83483,
		"trailing_return_y3": 17.33572,
		"trailing_return_y5": 12.28038,
		"trailing_return_y10": 10.88241,
		"trailing_return_y15": 12.09474,
		"trailing_return_y20": 9.55148,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "Morningstar Mid-Cap",
		"footprint": 211.17432119436003,
		"intensity": 276.1060472580773,
		"name": "IMCB - iShares Morningstar Mid-Cap ETF",
		"label": "IMCB - iShares Morningstar Mid-Cap ETF"
	},
	{
		"fund_id": "FSUSA04YKH",
		"investment_vehicle_id": "FEUSA04ACT",
		"ticker": "ISCB",
		"fund_legal_name": "iShares Morningstar Small-Cap ETF",
		"morningstar_category_name": "Small Blend",
		"fund_net_assets": 250508392,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 3,
		"grade_gender_equality": 4,
		"grade_dei": 3,
		"grade_rji": 3,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 3,
		"c2f5coogutweight": 0.06297101774273464,
		"cl_weight": 0.008263460794230612,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0.8873,
		"wff_mil_weight": 0.04939066267286486,
		"mmc_weight": 0.04939066267286486,
		"cm_weight": 0.0012236275423101097,
		"nw_weight": 0.018215129073981186,
		"wff_civ_weight": 0.0039028383740852676,
		"gm_weight": 0.0006358222274792723,
		"gr_weight": 0.0032670161466059953,
		"t_all_weight": 0.0007454597836631981,
		"to_weight": 0.0005181831788081073,
		"tm_weight": 0.0002272766048550908,
		"po_producer_weight": 0.002081617515194639,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.009301092430121784,
		"pp_weight": 0.00958461821413754,
		"borders_weight": 0.016052497939426688,
		"pp_high_weight": 0.0030980020253365058,
		"borders_high_weight": 0.005800640399510899,
		"pff_all_weight": 0.018083953935085464,
		"pff_all_high_weight": 0.005931051596806648,
		"pff_all_extreme_weight": 0.0009098743398828381,
		"gef_score_norm": 40.60842051568927,
		"gef_score_a": 20.75152727184209,
		"gef_score_b": 4.088992693958438,
		"gef_score_c": 15.7003830346086,
		"gef_score_d": 0.0675175152821783,
		"gef_score_a_norm": 51.878818179605226,
		"gef_score_b_norm": 13.629975646528125,
		"gef_score_c_norm": 78.501915173043,
		"gef_score_d_norm": 0.6751751528217829,
		"prospectus_net_expense_ratio": 0.04,
		"trailing_return_m1": 1.54102,
		"trailing_return_m3": 9.31285,
		"trailing_return_m6": 17.37201,
		"trailing_return_y1": 9.62049,
		"trailing_return_y3": 15.83359,
		"trailing_return_y5": 11.71766,
		"trailing_return_y10": 8.80463,
		"trailing_return_y15": 9.79805,
		"trailing_return_y20": 7.95906,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "Morningstar Small-Cap",
		"footprint": 153.85328193312995,
		"intensity": 146.31857820609906,
		"name": "ISCB - iShares Morningstar Small-Cap ETF",
		"label": "ISCB - iShares Morningstar Small-Cap ETF"
	},
	{
		"fund_id": "FSUSA06EC6",
		"investment_vehicle_id": "FEUSA04ADS",
		"ticker": "IWC",
		"fund_legal_name": "iShares Micro-Cap ETF",
		"morningstar_category_name": "Small Blend",
		"fund_net_assets": 985069201,
		"grade_fossil": 3,
		"grade_deforestation": 1,
		"grade_tobacco": 3,
		"grade_gender_equality": -1,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.032927727953738245,
		"cl_weight": 0,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.0328250925516542,
		"mmc_weight": 0.0328250925516542,
		"cm_weight": 0.0013520210846053571,
		"nw_weight": 0.006249169926660224,
		"wff_civ_weight": 0.003141173890009714,
		"gm_weight": 0.002888043923436637,
		"gr_weight": 0.00025312996657307716,
		"t_all_weight": 0.0038980952869103686,
		"to_weight": 0.0038980952869103686,
		"tm_weight": 0,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0,
		"pp_weight": 0.002630238393643152,
		"borders_weight": 0.0025095148243540213,
		"pp_high_weight": 0.002433254706080289,
		"borders_high_weight": 0.002433254706080289,
		"pff_all_weight": 0.002706498511916884,
		"pff_all_high_weight": 0.002433254706080289,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 27.806537369397926,
		"gef_score_a": 14.63986210796556,
		"gef_score_b": 5.079369172117743,
		"gef_score_c": 8.087306089314618,
		"gef_score_d": 0,
		"gef_score_a_norm": 36.5996552699139,
		"gef_score_b_norm": 16.931230573725813,
		"gef_score_c_norm": 40.43653044657309,
		"gef_score_d_norm": 0,
		"prospectus_net_expense_ratio": 0.6,
		"trailing_return_m1": 4.9552,
		"trailing_return_m3": 17.06915,
		"trailing_return_m6": 35.09714,
		"trailing_return_y1": 22.3326,
		"trailing_return_y3": 14.39931,
		"trailing_return_y5": 11.72666,
		"trailing_return_y10": 9.15376,
		"trailing_return_y15": 10.14208,
		"trailing_return_y20": 6.71227,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "Russell Microcap",
		"footprint": 243.54934065647353,
		"intensity": 169.31538594444189,
		"name": "IWC - iShares Micro-Cap ETF",
		"label": "IWC - iShares Micro-Cap ETF"
	},
	{
		"fund_id": "FSUSA0A2N9",
		"investment_vehicle_id": "F000003WKP",
		"ticker": "IWL",
		"fund_legal_name": "iShares Russell Top 200 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 1876853113,
		"grade_fossil": 4,
		"grade_deforestation": 2,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": 1,
		"grade_rji": 2,
		"grade_hrc": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.06355579409419056,
		"cl_weight": 0.3136637688854708,
		"fossil_bank_score": 36.292,
		"fossil_insure_score": 22.6844,
		"wff_mil_weight": 0.04746196009248438,
		"mmc_weight": 0.04746196009248438,
		"cm_weight": 0.007034356422903321,
		"nw_weight": 0.0258791009772488,
		"wff_civ_weight": 0.0108033895942211,
		"gm_weight": 0.001680269843193236,
		"gr_weight": 0.009123119751027864,
		"t_all_weight": 0.01796816353103615,
		"to_weight": 0.0074100362081031814,
		"tm_weight": 0.010558127322932969,
		"po_producer_weight": 0,
		"po_financier_weight": 0.03240455354720688,
		"po_consumer_weight": 0.11234780270940017,
		"pp_weight": 0.2207207687613106,
		"borders_weight": 0.2095732911987258,
		"pp_high_weight": 0.0015514753004237543,
		"borders_high_weight": 0.019766827815785475,
		"pff_all_weight": 0.2543409686540008,
		"pff_all_high_weight": 0.019766827815785475,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 55.10312731621564,
		"gef_score_a": 26.580530114364954,
		"gef_score_b": 9.417432856842488,
		"gef_score_c": 18.39789527851266,
		"gef_score_d": 0.7072690664820578,
		"gef_score_a_norm": 66.45132528591239,
		"gef_score_b_norm": 31.391442856141627,
		"gef_score_c_norm": 91.98947639256329,
		"gef_score_d_norm": 7.072690664820577,
		"prospectus_net_expense_ratio": 0.15,
		"trailing_return_m1": 4.13242,
		"trailing_return_m3": 8.6507,
		"trailing_return_m6": 21.44882,
		"trailing_return_y1": 19.42598,
		"trailing_return_y3": 26.65976,
		"trailing_return_y5": 16.84704,
		"trailing_return_y10": 16.13019,
		"trailing_return_y15": 15.15118,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "Russell Top 200",
		"footprint": 60.02532538962697,
		"intensity": 132.94129555375534,
		"name": "IWL - iShares Russell Top 200 ETF",
		"label": "IWL - iShares Russell Top 200 ETF"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/ExtendedBenchmarks.json
// module id = 959
// module chunks = 0